import { Command } from 'commands/Commands';


export class UpdateRedirect extends Command {
  type: string = 'UpdateRedirect';
  constructor(public newValue: string[]) {
    super(newValue)
  }
  priority: number = 100;

}
